// @ts-nocheck

import * as React from 'react';

/* ----------------------------- Text -------------------------------- */
export const AGENCY_TEXT = {
  NO_AGENCY_SCREEN: {
    TITLE: 'This page is not available in Agency view',
    BODY: 'Please use the app selector in the top left to view this page for a specific app',
  },
};

/* ----------------------------- Constants -------------------------------- */
export const SAVE_OPTIONS = {
  INHERITING_USERS: 'inheriting-users',
  ALL_USERS: 'all-users',
};

/* ----------------------------- Text -------------------------------- */
export const APP_AGENCY_MODAL_TEXT = {
  MODAL: {
    TITLE: 'App-level Agency Settings',
    DROPDOWN: {
      LABEL: 'Apply this setting to',
      TOOLTIP:
        'Choose which apps you would like to apply this setting to. By default, the setting will be applied to apps that do not have an individual setting and currently inherit their setting from the parent organization {org}. You can choose to override some or all app-specific settings here so they inherit from the organization as well.',
      INHERITING_USERS: "All {agency_name} users that inherit from {agency_name}'s app permissions",
      ALL_USERS: 'All {agency_name} users',
    },
  },
};

/* ------------------ Helper Methods / Text Components --------------------- */
export const getMessageText = (
  // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  selectedOption: 'inheriting-users' | 'all-users',
  agencyName: string
): React.ReactElement<any> => {
  return (
    <span>
      This will override all user permissions that are configured at the app level for all <b>{agencyName}</b> users.{' '}
      <span>
        You <span className="h_fw-700">cannot undo</span> this once you click Save.
      </span>
    </span>
  );
};
